import { gql } from '../__generated__'

export const GET_USER_ACCOUNT = gql(`
  query GetCurrentUserAccount {
    getCurrentUserAccount {
      ...CurrentUserAccountFragment
      organization {
        ...OrganizationFragment
      }
    }
  }
`)

export const CURRENT_ACCOUNT_ORGANIZATIONS = gql(`
  query CurrentAccountOrganizations {
    currentAccountOrganizations {
      id
      name
      providerId
    }
  }
`)

export const ALL_ACCOUNTS = gql(`
  query allAccounts {
    allAccounts {
      ...AccountFullFragment
    }
  }
`)

export const SEARCH_BASE_MILESTONES = gql(`
  query searchBaseMilestones($input: SearchNomenclatureInput) {
    searchBaseMilestones(input: $input) {
      baseMilestones {
        ...BaseMilestoneFragment
      }
    }
  }
`)
